// @ts-check

import { URL_PREVIEW_FILE } from 'constants/urls';

/**
 * @async
 * @function previewFile
 * @desc Fetches a file from the server and returns a URL to preview it.
 * @param {string} id
 * @returns {Promise<string>}
 */
async function previewFile(id) {
	const url = `${URL_PREVIEW_FILE}${id}`;

	const options = { method: 'GET' };

	let imgPath = '';

	const res = await fetch(url, options);

	if (res.ok) {
		const blobObj = await res.blob();
		imgPath = URL.createObjectURL(blobObj);
	} else {
		imgPath = '';
	}

	return imgPath;
}

export default previewFile;
